<nz-table
  class="v4-layout-list"
  #table
  [nzData]="listOfAccount"
  [nzTotal]="total"
  [(nzPageIndex)]="page"
  [nzPageSize]="pageSize"
  [nzPaginationType]="'small'"
  [nzFrontPagination]="false"
  [nzShowTotal]="totalTpl"
  (nzPageIndexChange)="onPageChange.emit($event)">
  <thead>
    <tr>
      <th class="w-1/4">{{ "channel.account" | translate }}</th>
      <th>{{ "channel.channel_house_quantity" | translate }}</th>
      <th>{{ "channel.account_status" | translate }}</th>
      <th>{{ "word.create_time" | translate }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody class="v4-layout-list-body">
    <tr *ngFor="let data of table.data; trackBy: trackByID">
      <td>
        <img
          class="mr-2 w-[22px] h-[22px] rounded-full"
          [src]="(data.thirdparty_type | thirdparty)?.icon_color"
          alt="" />
        <span>{{ data?.username }}</span>
      </td>
      <td>
        <span class="normal-font">
          {{ data.thirdparty_houses_count || 0 }}
        </span>
      </td>
      <td>
        <!--            v4-->
        <div [ngSwitch]="data.out_status" [class]="['status-tag', data.out_status]">
          <span *ngSwitchCase="'active'">
            {{ "channel-account_html_状态激活" | translate }}
            <!-- Active -->
          </span>
          <span *ngSwitchCase="'loading_listings'">
            {{ "channel-account_html_状态加载房源中" | translate }}
            <!-- Loading listings -->
          </span>
          <span *ngSwitchCase="'disconnected'">
            {{ "channel-account_html_状态断开" | translate }}
            <!-- Disconnected -->
          </span>
        </div>
        <!--            v4 end-->
      </td>
      <td>
        <span class="normal-font">{{ data.create_time | dateformat }}</span>
      </td>
      <td class="text-right whitespace-nowrap">
        <button
          class="mr-2"
          nz-button
          *ngIf="data.out_status === 'active' || data.out_status === 'loading_listings'"
          (click)="onSyncListings.emit(data)">
          {{ "word.get_channel_house" | translate }}
        </button>
        <button
          class="mr-2"
          nz-button
          nzType="primary"
          *ngIf="data.out_status === 'disconnected'"
          (click)="onReconnect.emit(data)">
          {{ "channel.re_authorize" | translate }}
          <!-- 重新授权 -->
        </button>

        @if (data.syncing_message_status === false) {
          <button class="mr-2" nz-button (click)="onCtripChangeUsername.emit(data)">Activate message syncing</button>
        }

        @if (data.thirdparty_type === Platform.TongCheng) {
          <button class="mr-2" nz-button nz-dropdown [nzDropdownMenu]="menu">
            {{ "thirdhub.pricelabs.operate.btn.add" | translate }}
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li
                nz-menu-item
                (click)="
                  onTongchengAddProperties.emit({
                    thirdparty_account_id: data.id,
                    type: 'house'
                  })
                ">
                {{ "component.sidebar.btn.add_house" | translate }}
                <!-- 添加房间 -->
              </li>
              <li
                nz-menu-item
                (click)="
                  onTongchengAddProperties.emit({
                    thirdparty_account_id: data.id,
                    type: 'type'
                  })
                ">
                {{ "component.sidebar.btn.add_house_type" | translate }}
                <!-- 添加房型 -->
              </li>
            </ul>
          </nz-dropdown-menu>
        }

        <button class="no-min-width" nz-button nz-dropdown [nzDropdownMenu]="menu">
          <!-- 更多 -->
          <!-- {{ "house.more" | translate }} -->
          <i nz-icon nzType="ellipsis"></i>
        </button>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu nzSelectable>
            @if (data.thirdparty_type !== Platform.Bookingsite) {
              <li nz-menu-item (click)="onDeleteAccount.emit(data.id)">
                {{ "channel.delete_account" | translate }}
                <!-- 删除账号 -->
              </li>
            }
            @if (data.thirdparty_type === Platform.CtripOffical && data.username) {
              <li nz-menu-item (click)="onCtripChangeUsername.emit(data)">
                {{ "Changer username" | translate }}
                <!-- 修改用户名 -->
              </li>
            }
            @if (data.can_modify_password) {
              <li nz-menu-item (click)="onChangePassword.emit(data)">
                {{ "word.change_password" | translate }}
                <!-- 修改密码 -->
              </li>
            }
          </ul>
        </nz-dropdown-menu>
      </td>
    </tr>
  </tbody>
</nz-table>
<ng-template #totalTpl>
  {{ "component-page_html_总数" | translate: { number: total } }}
  <!-- {{ total }} items -->
</ng-template>
